module.exports = __webpack_public_path__ + "static/2-7627f653a7ba523210faeb50e28dc478.png";